<template>
  <div class="email-body">
    <nav class="mail-nav">
      <a href="./">首页</a> /
      <span>收件箱</span>
    </nav>

    <div class="mail-search mail-flex">
      <div class="form">
        <label><span>发件人：</span><input type="text" placeholder="请输入" /> </label>
        <label><span>内容：</span><input type="text" placeholder="请输入" /> </label>
      </div>

      <div>
        <v-btn @click="resetFilters" size="small" variant="outlined">重置</v-btn>
        <v-btn @click="filterEmails" size="small" variant="flat" color="primary">查询</v-btn>
      </div>
    </div>

    <div class="mail-list">
      <div class="mail-cont mail-flex">
        <div class="mail-title">
          收件箱 (<span class="red">{{ unreadCount }}</span> 封未读)
        </div>

        <div class="btns">
          <v-btn @click="deleteEmails" variant="outlined">删除</v-btn>
          <v-btn @click="permanentlyDelete" size="small" variant="outlined">彻底删除</v-btn>
          <v-btn @click="forward" size="small" variant="outlined">转发</v-btn>
          <v-btn @click="markAllRead" size="small" variant="outlined">全部已读</v-btn>
        </div>
      </div>

      <div class="mail-table">
        <table id="mailbox">
          <thead>
            <tr>
              <th width="30px"><input type="checkbox" v-model="selectAll" @change="toggleAll" /></th>
              <th width="30px"><!--图标--></th>
              <th width="300px">姓名</th>
              <th>内容</th>
              <th width="150px">日期</th>
            </tr>
          </thead>
          <tbody>
            <template v-for="(group, groupKey) in groupedEmails" :key="groupKey">
              <tr>
                <td class=""></td>
                <td colspan="4" class="mail-grp">{{ groupKey }}</td>
              </tr>
              <tr v-for="email in group" :key="email.id">
                <td class="td1"><input type="checkbox" v-model="email.selected" /></td>
                <td class=""><v-icon icon="mdi-email-outline" size="small" color="#0000df"></v-icon></td>
                <td class="">{{ email.sender }}</td>
                <td><a class="pointer" @click="openEmail(email)">{{ email.subject }}</a></td>
                <td class="">{{ email.date }}</td>
              </tr>
            </template>
          </tbody>
        </table>
      </div>
      <v-pagination :length="4" size="small"></v-pagination>
    </div>
  </div>
</template>

<script setup>
import { reactive, computed, ref } from 'vue';
import { useRouter } from 'vue-router';
// import HeaderView from "../components/Header.vue";

const router = useRouter()

const emails = reactive([
  { id: 1, sender: '456@qq.com', subject: 'Re: Re: python接口调试', date: '2025-05-12 09:46:02', selected: false },
  { id: 2, sender: '123@qq.com', subject: 'Re: Re: Re: python接口调试', date: '2025-05-09 17:47:20', selected: false },
  // ... more emails
]);

const filters = reactive({ sender: '', content: '' });
const selectAll = ref(false);

const groupedEmails = computed(() => {
  const today = new Date().toISOString().split('T')[0];
  const groups = { '今天': [], '更早': [] };
  emails.forEach(email => {
    if (email.date.startsWith(today)) {
      groups['今天'].push(email);
    } else {
      groups['更早'].push(email);
    }
  });

  for (const group in groups) {
    if (groups[group].length === 0) {
      delete groups[group];
    }
  }
  return groups;
});

const unreadCount = computed(() => emails.length); // replace with actual unread logic

function filterEmails() {
  // Implement filtering logic if needed
  console.log('Filtering:', filters);
}

function resetFilters() {
  filters.sender = '';
  filters.content = '';
}

function toggleAll() {
  emails.forEach(email => {
    email.selected = selectAll.value;
  });
}

function markAllRead() {
  console.log('Mark all as read');
}

function deleteEmails() {
  console.log('Delete selected emails');
}

function permanentlyDelete() {
  console.log('Permanently delete selected emails');
}

function forward() {
  console.log('Forward selected emails');
}

function openEmail(email) {
  console.log('Open email:', email);
  router.push('./maildetail') // 跳转到某个页面
}
</script>

<style>
@import '../assets/styles/email.css';
</style>
